import { toast } from "react-toastify";
import ErrorToster from "../components/TosterComponents/ErrorToster";

export function isNullOrUndefined(value) {
  return (
    value === null ||
    value === undefined ||
    value.length === 0 ||
    value === "NaN" ||
    value === "NA" ||
    NaN
  );
}

export const convertFileToUint8Array = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();

      reader.onload = (event) => {
        const uintArray = new Uint8Array(event.target.result);
        resolve(uintArray);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    } catch (error) {
      reject(error);
    }
  });
};

export const convertBase64ToUint8Array = (base64) => {
  // Remove data URL prefix if present
  const base64String = base64.replace(/^data:image\/\w+;base64,/, "");

  // Convert Base64 string to binary string
  const binaryString = window.atob(base64String);

  // Create a Uint8Array with the same length as the binary string
  const length = binaryString.length;
  const uintArray = new Uint8Array(length);

  // Populate the Uint8Array with the binary data
  for (let i = 0; i < length; i++) {
    uintArray[i] = binaryString.charCodeAt(i);
  }

  return uintArray;
};

export const findParentKey = (obj, targetKey) => {
  for (const key in obj) {
    if (
      obj[key] &&
      typeof obj[key] === "object" &&
      !Array.isArray(obj[key]) &&
      targetKey in obj[key]
    ) {
      return key;
    }
  }
  return null;
};

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName)?.length === 0;
};

export function generateRandomNumber() {
  return Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;
}

export function splitNumberIntoArray(number) {
  return number.toString().split("").map(Number);
}

export const debounce = (func, delay) => {
  let debounceTimer;
  return function (...args) {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

export const copyToClipboard = (element) => {
  navigator?.clipboard
    ?.writeText(element)
    .then(() => {
      return { code: 200 };
    })
    .catch((err) => {
      return { code: 404 };
    });
};

export const encodeMessageForURL = (message) => {
  return encodeURIComponent(message)
    .replace(/%20/g, "+")
    .replace(/%0A/g, "%0A");
};

export function getCurrentDate(separator = "/") {
  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();

  return `${date}${separator}${
    month < 10 ? `0${month}` : `${month}`
  }${separator}${year}`;
}

export const fileSelectHandler = async (acceptType) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = acceptType;

  return new Promise((resolve, reject) => {
    input.onchange = async (e) => {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = async (event) => {
        try {
          const imageDataURL = event.target.result;
          const uint8Array = await convertFileToUint8Array(file);

          resolve({
            uint8Array: uint8Array,
            fileDetail: file,
            base64: imageDataURL,
          });
        } catch (error) {
          toast(<ErrorToster errorMessage={error.message} />, {
            toastId: "upload-signature-error",
          });
          reject(error);
        }
      };

      reader.onerror = (error) => {
        toast(<ErrorToster errorMessage="File reading error" />, {
          toastId: "file-read-error",
        });
        reject(error);
      };

      reader.readAsDataURL(file);
    };

    input.click();
  });
};
